import { AxiosError } from "axios";
import i18n from "../i18n";

export class HttpError extends Error {
  readonly statusCode: number;
  readonly data: unknown;
  /** True when the request never reached the server (down, unreachable, CORS, offline). */
  readonly isNetworkError: boolean;

  constructor(axiosError: AxiosError) {
    super(HttpError.resolveMessage(axiosError));
    this.name = "HttpError";
    this.statusCode = axiosError.response?.status ?? 0;
    this.data = axiosError.response?.data;
    this.isNetworkError = !axiosError.response;
  }

  private static resolveMessage(axiosError: AxiosError): string {
    if (!axiosError.response) {
      return i18n.t("Unable to reach the server. Please check your connection and try again.");
    }
    // Support both a plain { message } body and RFC 9110 problem-details
    // ({ detail, title, ... }), which the portal API uses for 4xx errors.
    const data = axiosError.response.data as
      | { message?: string; detail?: string; title?: string }
      | undefined;
    return data?.message ?? data?.detail ?? data?.title ?? axiosError.message ?? "Request failed";
  }
}
